import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import CloseIcon, { SIZES } from 'components/CloseIcon';
import Paragraph from 'components/Paragraph';
import Theme from 'styles/theme';

const Chip = ({ className, children, ...otherProps }) => (
  <button className={classNames('Chip', className)} {...otherProps}>
    <Paragraph className="Chip__text">{children}</Paragraph>
    <CloseIcon size={SIZES.SMALL} disableHoverAnimation />
    <style jsx>
      {`
        .Chip {
          display: flex;
          align-items: center;
          max-width: 100%;
          min-height: ${Theme.get('spacing') * 5}px;
          padding: 0 ${Theme.get('spacing-px')};
          border: 1px solid ${Theme.get('colors-black-20')};
          border-radius: ${Theme.get('border-radius-capsule-px')};
          outline: 0;
          background-color: transparent;
          cursor: pointer;
          appearance: none;
          transition: border-color ${Theme.get('transition-duration-ms')};
        }

        .Chip:hover,
        .Chip.focused {
          border-color: ${Theme.get('colors-black-80')};
        }
      `}
    </style>
    <style jsx global>
      {`
        .Chip .Paragraph {
          flex: 1;
          margin: 0 ${Theme.get('spacing-px')};
          white-space: nowrap;
          overflow: hidden;
        }

        .Chip .CloseIcon {
          display: block;
          box-sizing: content-box;
          padding: ${Theme.get('spacing') / 3}px;
          background-color: ${Theme.get('colors-black-80')};
          border-radius: 50%;
          opacity: 0.8;
          transition: opacity ${Theme.get('transition-duration-ms')};
        }

        .Chip:hover .CloseIcon,
        .Chip.focused .CloseIcon {
          opacity: 1;
        }

        .Chip .CloseIcon:before,
        .Chip .CloseIcon:after {
          background-color: ${Theme.get('colors-white')};
          width: 1px;
          height: 10px;
        }
      `}
    </style>
  </button>
);

Chip.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

Chip.defaultProps = {
  className: '',
};

export default Chip;
